// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"2af2f82a","1851":"b1f4c4a3","1872":"6480a638","3256":"d1836648","4549":"240c9479","4863":"6480a638","5220":"2d4c3922","8315":"73566fa2","8694":"e18c164f","9179":"73566fa2"}[chunkId] + ".chunk.css";
};